import { createContext } from "react";

const DepartureProductsContext = createContext();

export default DepartureProductsContext;
